import { TemplateRef } from '@angular/core';
import * as i0 from "@angular/core";
const _c0 = ["*"];
export let UiHeaderComponent = /*#__PURE__*/(() => {
  class UiHeaderComponent {
    static {
      this.ɵfac = function UiHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiHeaderComponent,
        selectors: [["ui-header"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function UiHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%] >   :first-child{margin-top:0}\n\n/*# sourceMappingURL=shared.ts-angular-inline--3.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UiHeaderComponent;
})();
export let UiFooterComponent = /*#__PURE__*/(() => {
  class UiFooterComponent {
    static {
      this.ɵfac = function UiFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiFooterComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiFooterComponent,
        selectors: [["ui-footer"]],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function UiFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%] >   :last-child{margin-bottom:0}\n\n/*# sourceMappingURL=shared.ts-angular-inline--4.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UiFooterComponent;
})();
export let UiTemplateDirective = /*#__PURE__*/(() => {
  class UiTemplateDirective {
    constructor(template) {
      this.template = template;
    }
    getType() {
      return this.name;
    }
    static {
      this.ɵfac = function UiTemplateDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: UiTemplateDirective,
        selectors: [["", "uiTemplate", ""]],
        inputs: {
          type: "type",
          name: [0, "uiTemplate", "name"]
        }
      });
    }
  }
  return UiTemplateDirective;
})();
export const UiHeaderFooterBundle = [UiHeaderComponent, UiFooterComponent, UiTemplateDirective];
export const UiSharedBundle = UiHeaderFooterBundle;